export default __webpack_public_path__ + "static/media/map.c3c2a42a.png";